module.exports = __webpack_public_path__ + "img/Group 28813.2120e058.svg";